import { route } from '@/ziggy-shim';
import { api, apiConfig, CastValue } from './LaravelClient';

export default {
  async create(claimId: Id, sharedFundId: Id, data: ApiRequests['api.v1.shared-fund-costs.store']) {
    return await api(route('api.v1.shared-fund-costs.store', { claim: claimId, shared_fund: sharedFundId }), 'post', {
      data,
      casts: {
        current_certified: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        current_claim: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        comment: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  async update(id: Id, data: ApiRequests['api.v1.shared-fund-costs.update']) {
    return await api(route('api.v1.shared-fund-costs.update', id), 'patch', {
      data,
      casts: {
        current_certified: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        current_claim: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        comment: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  async updateComment(
    sharedFundCostId: Id,
    commentId: Id,
    data: ApiRequests['api.v1.shared-fund-costs.comments.update'],
  ) {
    return await api(
      route('api.v1.shared-fund-costs.comments.update', [sharedFundCostId, commentId]),
      'patch',
      {
        data,
      },
    );
  },

  async deleteComment(sharedFundCostId: Id, commentId: Id) {
    return await api(
      route('api.v1.shared-fund-costs.comments.destroy', [sharedFundCostId, commentId]),
      'delete',
    );
  },

  async delete(id: Id) {
    return await api(route('api.v1.shared-fund-costs.destroy', id), 'delete');
  },

  async claim(claimId: Id, signedParams: unknown, data: ApiRequests['api.v1.claims.shared-fund.claim.store']) {
    return await apiConfig(route('api.v1.claims.shared-fund.claim.store', claimId), 'post', {
      params: signedParams,
      paramsSerializer: {
        serialize: (params) => {
          return new URLSearchParams(params).toString();
        },
      },
    }, {
      data,
      casts: {
        id: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  async certified(claimId: Id, signedParams: unknown, data: ApiRequests['api.v1.claims.shared-fund.certified.store']) {
    return await apiConfig(route('api.v1.claims.shared-fund.certified.store', claimId), 'post', {
      params: signedParams,
      paramsSerializer: {
        serialize: (params) => {
          return new URLSearchParams(params).toString();
        },
      },
    }, {
      data,
      casts: {
        comment: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  comments: {
    async updateSigned(
      claimId: Id,
      signedParams: unknown,
      data: ApiRequests['api.v1.claims.shared-fund-costs.comments.update.signed'],
    ) {
      return await apiConfig(route('api.v1.claims.shared-fund-costs.comments.update.signed', claimId), 'patch', {
        params: signedParams,
        paramsSerializer: {
          serialize: (params) => {
            return new URLSearchParams(params).toString();
          },
        },
      }, {
        data,
      });
    },

    async storeSigned(
      claimId: Id,
      signedParams: unknown,
      data: ApiRequests['api.v1.claims.shared-fund-costs.comments.store.signed'],
    ) {
      return await apiConfig(route('api.v1.claims.shared-fund-costs.comments.store.signed', claimId), 'post', {
        params: signedParams,
        paramsSerializer: {
          serialize: (params) => {
            return new URLSearchParams(params).toString();
          },
        },
      }, {
        data,
      });
    },
  },
};
